import babelcast from './babelcast';
import crossroads from './crossroads';
import excalibrr from './excalibrr';
import freightInvoicing from './freight_invoicing';
import straata from './straata';
import narrative from './narrative';

export const caseStudies = [
  babelcast,
  crossroads,
  excalibrr,
  freightInvoicing,
  straata,
  narrative,
];

export {
  babelcast,
  crossroads,
  excalibrr,
  freightInvoicing,
  straata,
  narrative,
};
